import { gameElapsedMs, gameLengthMs, type GameState, type PointEvent } from "./types";

/** Celebrate one newly recorded point, never a correction, replay or batch
 * caught up after a connection gap. Credit edits are not scoring events. */
export function newLivePoint(previous: GameState | null, next: GameState, now: number): PointEvent | null {
  if (!previous || !["h1", "h2"].includes(next.period) ||
    previous.fieldId !== next.fieldId || previous.scheduleGameId !== next.scheduleGameId ||
    previous.teamA.teamId !== next.teamA.teamId || previous.teamB.teamId !== next.teamB.teamId ||
    previous.teamA.name !== next.teamA.name || previous.teamB.name !== next.teamB.name) return null;
  const before = previous.points ?? [], after = next.points ?? [];
  const point = after.at(-1);
  if (!point || after.length !== before.length + 1 || now - point.at > 15_000 || point.at > now + 5_000) return null;
  if (before.some((p, i) => {
    const q = after[i];
    return !q || p.at !== q.at || p.team !== q.team || p.scoreA !== q.scoreA || p.scoreB !== q.scoreB;
  })) return null;
  const a = point.team === "A" ? 1 : 0, b = point.team === "B" ? 1 : 0;
  return next.teamA.score === previous.teamA.score + a && next.teamB.score === previous.teamB.score + b &&
    point.scoreA === next.teamA.score && point.scoreB === next.teamB.score ? point : null;
}

/** The final five minutes of the whole game, regardless of clock display mode.
 * A clock reaching zero never ends a game; the scorekeeper does. */
export function liveFinish(state: GameState, now: number) {
  const active = state.period === "h1" || state.period === "h2";
  const left = gameLengthMs(state.config) - gameElapsedMs(state, now);
  const target = state.config.scoreTarget;
  const a = target !== null && state.teamA.score === target - 1;
  const b = target !== null && state.teamB.score === target - 1;
  return {
    urgent: active && left <= 5 * 60_000,
    point: active && (a || b) ? (a && b ? "universe" : "game") : null,
    winner: state.period === "final" && state.teamA.score !== state.teamB.score
      ? (state.teamA.score > state.teamB.score ? "A" : "B") : null,
  } as const;
}
